





















import BusinessItem from '../common/business_item.vue'
import SearchLoadList from '../mixins/LoadList'
import { Component, Mixins, Provide, Inject } from 'vue-property-decorator'
import SearchCategory from '../common/search_category.vue'
import Screen from '../common/search_screen.vue'
import { List, Toast, Sticky } from 'vant'
import { namespace } from 'vuex-class'
import { getSearchResult, RequestType } from '../../search-service'
import { SearchRefresh } from '../searchAll/index.vue'

const searchResModule = namespace('searchRes') //vuex

@Component({
  components: {
    [List.name]: List,
    [Sticky.name]: Sticky,
    BusinessItem,
    SearchCategory,
    Screen
  }
})
export default class SearchBusiness extends Mixins(SearchLoadList) {
  @searchResModule.Mutation setBusinessNum!: (arg: number) => void

  @searchResModule.State location!: any
  @searchResModule.State categoryList!: any
  @searchResModule.State businessCategorySelect!: any
  @searchResModule.Mutation setBusinessCategorySelect!: any

  @searchResModule.State districtList!: any
  @searchResModule.State businessDistrictSelect!: any
  @searchResModule.Mutation setBusinessDistrictSelect!: any

  @searchResModule.State businessDistanceSort!: boolean
  @searchResModule.State businessGoodCommentSort!: boolean
  @searchResModule.Mutation setBusinessDistanceSort!: (arg: any) => void //设置商家距离排序
  @searchResModule.Mutation setBusinessGoodCommentSort!: (arg: any) => void //设置商家好评排序

  @searchResModule.Mutation resetBusiness!: () => void ////重置筛选项

  @Inject('pageTrackParams')
  pageTrackParams!: any
  @Inject('clickid_200008')
  clickid_200008!: string

  //搜索结果页商家点击clickid
  @Provide()
  clickid_200003 = '200004'
  @Provide()
  clickid_200002 = '200003'
  @Provide()
  clickid_200001 = '200002'

  mounted() {
    const { searchKey = '', tabs = '' } = this.$route.query
    this.keyWord = searchKey as string
    this.tabs = tabs as string
    this.onLoad()

    //防止该页面没有创建时 调两次接口
    setTimeout(() => {
      this.$bus.$on(SearchRefresh.RefreshBusiness, () => {
        this.refresh()
      })
    }, 1000)
  }

  destroyed() {
    this.$bus.$off(SearchRefresh.RefreshBusiness)
  }

  //距离排序是否展示
  get locationVis() {
    return this.location && this.location.lat && this.location.lng
  }

  //空页面的高度
  get emptyHeight() {
    const { top, height } = (this.$refs.classify as HTMLElement).getBoundingClientRect() || {}
    return document.body.clientHeight - top - height
  }

  get classifyExposure() {
    return `${this.clickid_200008}`
  }
  
  changeBusinessCategory(value: any) {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200008,positionParam:{searchtype:'分类'}})
    this.setBusinessCategorySelect(value)
    this.refresh()
  }

  changeBusinessDistrict(value: any) {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200008,positionParam:{searchtype:'区域'}})
    this.setBusinessDistrictSelect(value)
    this.refresh()
  }

  //排序互斥
  changeBusinessDistanceSort() {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200008,positionParam:{searchtype:'距离'}})
    if (this.loading) return
    this.setBusinessDistanceSort(!this.businessDistanceSort)
    if (this.businessDistanceSort) {
      this.setBusinessGoodCommentSort(false)
    }
    this.refresh()
  }
  changeGoodCommentSort() {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200008,positionParam:{searchtype:'好评'}})
    if (this.loading) return
    this.setBusinessGoodCommentSort(!this.businessGoodCommentSort)
    if (this.businessGoodCommentSort) {
      this.setBusinessDistanceSort(false)
    }
    this.refresh()
  }

  async onLoad() {
    const { categoryId = '' } = this.businessCategorySelect || {}
    const { ID = '' } = this.businessDistrictSelect || {}
    const result = await getSearchResult({ tabs: this.tabs, keyWords: this.keyWord, type: RequestType.RequestBuiness, start: this.start, position: this.location, level4CategoryId: categoryId, districtId: ID, distanceSort: this.businessDistanceSort, storeFavPersonNumSort: this.businessGoodCommentSort })
    const { code, data, msg } = result
    if (+code === 1) {
      if (data.businessInfo) {
        const { total, list: newData = [] } = data.businessInfo
        this.setBusinessNum(total)
        if (newData.length < 10) {
          this.finished = true
        }
        this.start = this.start + newData.length
        this.list.push(...newData)
      }
    } else {
      this.errormsg = msg || '加载出错，请稍后再试'
      if (this.list.length > 0) {
        this.error = true
        Toast(this.errormsg)
      }
    }
    this.loading = false
  }

  async refresh() {
    this.reset()
    this.$nextTick(() => {
      if (this.isFixed) {
        window.scrollTo(0, this.scrollTop)
      }
    })
    this.onLoad()
  }

  resetCondition() {
    this.resetBusiness()
    this.refresh()
  }
}
